import { render } from "./NobleShop.vue?vue&type=template&id=20f2912c&scoped=true"
import script from "./NobleShop.vue?vue&type=script&lang=js"
export * from "./NobleShop.vue?vue&type=script&lang=js"

import "./NobleShop.vue?vue&type=style&index=0&id=20f2912c&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20f2912c"]])

export default __exports__